export default __webpack_public_path__ + "static/ausflag-a4329b21731a59531f42ea2d4ffe20c9.jpg";